import React from 'react';
import { Box, Typography } from '@mui/material';
import { config } from '../../config';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 'auto',
        backgroundColor: 'rgba(245, 245, 245, 1)',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          fontSize: '0.875rem',
          fontWeight: 500,
        }}
      >
        Version {config.APP_VERSION}
      </Typography>
    </Box>
  );
};

export default Footer;

